<template>
  <div>
    <v-autocomplete
      v-model="selected"
      :items="addresses"
      :label="label"
      :filter="filter"
      :no-data-text="lang.customers.datatable.no_address_results"
      item-text="address"
      item-value="cep"
      :return-object="returnObject"
      filled
      chips
      multiple
      :clearable="clearable"
      clear-icon="mdi-broom"
      :class="{ 'hide-chips': hideChips }"
      autocomplete="off"
      hide-details
    >
      <template v-slot:selection="data">
        <v-chip
          v-if="!hideChips"
          :input-value="data.selected"
          close
          class="chip--select-multi"
          @click:close="remove(data.item)"
        >
          {{ `${data.item.address} (${data.item.cep}) - ${data.item.city}/${data.item.state}` }}
        </v-chip>
      </template>
      <template v-slot:item="data">
        <template v-if="typeof data.item !== 'object'">
          <v-list-item-content>
            <v-list-item-title>{{ data.item }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <template v-else>
          <v-list-item-content>
            <v-list-item-title>{{ `${data.item.address} ${(data.item.cep !== '' && data.item.cep !== undefined ? ' - ' + data.item.cep : '')}` }}</v-list-item-title>
            <v-list-item-subtitle>{{ `${data.item.neighborhood} - ${data.item.city}/${data.item.state} ${(data.item.country !== '' && data.item.country !== undefined ? '-' + data.item.country : '')}` }}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    label: {
      type: String,
      default: () => {
        return this.lang.historic.filters.addresses.title
      }
    },
    hideChips: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selected: (this.value ? [ ...this.value ] : [])
    }
  },
  computed: {
    addresses: function () {
      var addresses = this.get_data.customers.map(function (el) { return el.addresses })
      const addressesArr = Object.values(addresses)
      const flattenArray = addressesArr.reduce((add, val) => add.concat(val), [])
      const uniqueArray = flattenArray.reduce((acc, current) => {
        const x = acc.find(item => item.cep === current.cep)
        return (!x ? acc.concat([current]) : acc)
      }, [])
      let group = uniqueArray.reduce((r, a) => {
        r[a.city + '/' + a.state] = [...r[a.city + '/' + a.state] || [], a]
        return r
      }, [])
      console.log('group', group)
      const flatten = uniqueArray.reduce((add, val) => add.concat(val), [])
      console.log('flatten', flatten)
      const result = []
      var currentCity = null
      flatten.forEach((value) => {
        if (currentCity !== `${value.city}/${value.state}`) result.push({ header: `${value.city} / ${value.state}` })
        result.push(value)
        currentCity = `${value.city}/${value.state}`
      })
      //console.log('result', result)
      return result
    }
  },
  watch: {
    selected: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.value) !== JSON.stringify(newVal)) this.$emit('input', [ ...this.selected ])
      }
    },
    value: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.selected) !== JSON.stringify(newVal)) this.selected = [ ...this.value ]
      }
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    filter (item, queryText, itemText) {
      if (typeof item.header === 'undefined' && queryText) {
        console.log('item', item)
        console.log('queryText', queryText)
        return (
          (item.address.toLowerCase().trim().search(queryText.toLowerCase()) > -1) ||
          (String(item.cep).toLowerCase().trim().search(String(queryText)) > -1) ||
          (item.neighborhood.toLowerCase().trim().search(queryText.toLowerCase()) > -1) ||
          (item.city.toLowerCase().trim().search(queryText.toLowerCase()) > -1) ||
          (item.state.toLowerCase().trim().search(queryText.toLowerCase()) > -1) ||
          (item.country.toLowerCase().trim().search(queryText.toLowerCase()) > -1)
        )
      }
    },
    remove (item) {
      const obj = (this.returnObject ? this.selected.find(el => el.id === item.id) : this.selected.find(el => el === item.id))
      const index = this.selected.indexOf(obj)
      if (index >= 0) this.selected.splice(index, 1)
    }
  }
}
</script>

<style scoped src="../../styles/autocomplete.scss" lang="scss"></style>
